import { render, staticRenderFns } from "./formOption.vue?vue&type=template&id=6c797d18&"
import script from "./formOption.vue?vue&type=script&lang=js&"
export * from "./formOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c797d18')) {
      api.createRecord('6c797d18', component.options)
    } else {
      api.reload('6c797d18', component.options)
    }
    module.hot.accept("./formOption.vue?vue&type=template&id=6c797d18&", function () {
      api.rerender('6c797d18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/project/manage/components/formOption.vue"
export default component.exports